(ns common.archive-modal.db
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx :confirm-archive/init
  (fn []
    {:forward-events [{:register :close-modal
                       :events #{:resource.advertiser/patch-success
                                 :resource.adset/patch-success}
                       :dispatch-to [:modal/close]}]}))

(rf/reg-event-fx :confirm-archive/destroy
  (fn []
    {:forward-events [{:unregister :close-modal}]}))
